export var ActivityBasedSchedulingRoutes = {
    "/forecasts-projections/:start_date": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecasts-projects",
        "showGlobalSearch": true,
        "params": {start_date: ""},
        "type": "frontend",
        "views": {
            "body": {
                component: 'forecastsProjectionsComponent',
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import('../team-live/activity-based-scheduling-generation/activity-based-scheduling-generation.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling.module.js");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["abs-generation"]
        },
        "onEnter": ['$state', 'TeamScheduleService', 'hUser', function ($state, TeamScheduleService, hUser) {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    if (!TeamScheduleService.isABSServiceEnabled() || !hUser.hasSalesAccess()) {
                        $state.go("appLayout.schedule.main");
                    }
                });
        }]
    },
    "/forecasts-and-labor": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecasts-and-labor",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                component: "forecastsAndLaborComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Forecasts"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling.module.js");
                }
            },
        ],
        "onEnter": ['$q', 'userServices', '$state', 'TeamScheduleService', 'hUser',
            function ($q, userServices, $state, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        var promises = {};
                        promises['isABSServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, brand.id);
                        promises['isDemandForecastingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.DEMAND_FORECASTING, brand.id);

                        $q.all(promises)
                            .then(function (res) {
                                if ((!res.isABSServiceEnabled && !res.isDemandForecastingEnabled) || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                    });
            }]
    },
    "/forecasts-templates/:start_date": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecasts-templates",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                component: 'forecastsTemplatesContainer',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling.module.js");
                }
            },
        ],
        "onEnter": ['userServices', '$state', 'TeamScheduleService', 'hUser', function (userServices, $state, TeamScheduleService, hUser) {
            TeamScheduleService.getActiveBrand()
                .then(function (brand) {
                    var promises = {};
                    promises['isABSServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, brand.id);
                    promises['isDemandForecastingEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.DEMAND_FORECASTING, brand.id);

                    $q.all(promises)
                        .then(function (res) {
                            if (!res.isABSServiceEnabled || res.isDemandForecastingEnabled || !hUser.hasSalesAccess()) {
                                $state.go("appLayout.schedule.main");
                            }
                        })
                        .catch(function (err) {
                            console.error(err);
                        });
                });
        }]
    },
    "/forecast-rule/:rule_id?duplicate_id&step": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecast-settings-rule",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                component: 'manageAbsForecastRuleContainer',
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: [
                'abs-settings',
            ],
        },
        "params": {
            "rule_id": {
                value: null,
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling-settings.module.js");
                }
            },
        ],
        "onEnter": ['TeamScheduleService', 'userPermissions', 'userServices', '$state', async (TeamScheduleService, userPermissions, userServices, $state) => {
            let activeBrand =  await TeamScheduleService.getActiveBrand();

            try {
                const [
                    policyParser,
                    isABSServiceEnabled,
                    settings
                ] = await Promise.all([
                    userPermissions.getBrandPolicy(activeBrand.id),
                    userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, activeBrand.id, true),
                    ActivityBasedSchedulingAPI.getABSBrandSettings(activeBrand.id)
                ]);

                let canManageForecastingSettings = policyParser.has(userPermissions.PERMISSIONS.MANAGE_FORECASTING_SETTINGS);

                if (!(settings?.bulk_rule_apply_enabled && isABSServiceEnabled && canManageForecastingSettings && activeBrand.id === activeBrand.parent_id)) {
                    $state.go("appLayout.schedule.settings", { activeTab: 'GENERAL' });
                }
            } catch (error) {
                $state.go("appLayout.schedule.settings", { activeTab: 'GENERAL' });
            }
        }],
    },
    "/forecast-templates-rule/:rule_id?duplicate_id&step": {
        "name": "appLayout.harriSH.access-portal.settings.forecast-settings-rule",
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": 'manageAbsForecastRuleContainer',
        "route_styles": {
            framework: "bootstrap_v4",
            styles: [
                'abs-settings',
            ],
        },
        "params": {
            "rule_id": {
                value: null,
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./activity-based-scheduling-settings.module.js");
                }
            },
        ],
        "onEnter": ['hUser', 'userPermissions', 'userServices', '$state', 'hmapService', async (hUser, userPermissions, userServices, $state, hmapService) => {
            let activeBrandId = hUser.getActiveBrandId();

            try {
                const [
                    policyParser,
                    isABSServiceEnabled,
                    settings,
                    isHighestParent
                ] = await Promise.all([
                    userPermissions.getBrandPolicy(activeBrandId),
                    userServices.isServiceEnabled(userServices.SERVICES.ACTIVITY_BASED_SCHEDULING, activeBrandId, true),
                    ActivityBasedSchedulingAPI.getAbsBusinessSettings(activeBrandId),
                    hmapService.isHighestParent(activeBrandId),
                ]);

                let canManageForecastingSettings = policyParser.has(userPermissions.PERMISSIONS.MANAGE_FORECASTING_SETTINGS);

                if (!(settings?.bulk_rule_apply_enabled && isABSServiceEnabled && canManageForecastingSettings && isHighestParent)) {
                    $state.go("appLayout.harriSH.access-portal.settings.main", {activeTab: 'GENERAL'});
                }
            } catch (error) {
                $state.go("appLayout.harriSH.access-portal.settings.main", {activeTab: 'GENERAL'});
            }
        }],
    },
};